export default "__VITE_ASSET__BnER7QTE__"